export function calculateAge(birthDate: {
  year: string | number;
  month: string | number;
  day: string | number;
}) {
  if (!birthDate || !birthDate.year || !birthDate.month || !birthDate.day) return 0;

  const today = new Date();
  const birthDateObj = new Date(
    Number(birthDate.year),
    Number(birthDate.month) - 1,
    Number(birthDate.day)
  );

  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
    age--;
  }

  return age;
}
